
function toggleCart(){
  const sideBar = document.getElementById('cart-side');
  if(sideBar.style.display == 'block'){
    	sideBar.style.display = 'none';
    } else {
      sideBar.style.display = 'block';
    }
}


function showCart(){
  const sideBar = document.getElementById('cart-side');
  sideBar.style.display = 'block';
}

function addToCart(product){
  const object = {
    items: [{
      id: product,
      quantity: 1,
    }]
  };
  const url='/cart/add.js';   
  fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(object),
  })
  .then(response => response.json())
  .then(cart => {
    if (cart?.status === 422){
        showCart();
    }
    if(cart.hasOwnProperty('items')){
      addItemToCartSidebar(cart.items[0]);
      showCart();
      showToaster('Item successfully added to cart', 'success');
    } else {
      showToaster(cart.description, 'error');
    }
  })
}

function removeProduct(product_id) {
    const url='/cart/update.js';
    const object = {updates:{}};
    object.updates[product_id]=0;
 	fetch(url, {
      method: 'POST',
	  cache: 'no-cache',
      headers: {
      	'Content-Type': 'application/json',
      },
      body:JSON.stringify(object),
    })	
	.then(response => response.json())
    .then(cart => {
      removeItemFromCartSidebar(cart, product_id);
    })
}

function addItemToCartSidebar(product){
  toggleSideBarVisibility('show');
  updateCartLabel('add');
  drawNewIteminSidebar(product);
}

function removeItemFromCartSidebar(cart, product_id){
	const stillExistsInCart = cart?.items?.filter((item)=> item.variant_id == product_id).length > 0; 
    if(!stillExistsInCart){
    	$('#'+product_id).remove();
    	if(cart.items.length == 0){
    		toggleSideBarVisibility('hide');
		} else {
    		toggleSideBarVisibility('show');
    	}
		updateCartLabel('remove');
	}
}

function drawNewIteminSidebar(product) {
  
  	const form = $('#cart');

    jQuery.getJSON('/cart.js', function(cartUpdated) {
      setAmount(cartUpdated.item_count);
      form.html("");
      for(const productItem of cartUpdated.items ){

        const product_div = mountProductSidebarCartHTML(productItem);
        form.append(product_div);
      }

    });
    return;

}

function mountProductSidebarCartHTML(product){
    const elem = document.getElementById(product.product_id + "_200x");
    const image = elem == null ? product.image : elem.value;
	return `<a href="${ product.url }" >
    			<div id="${ product.variant_id }"
    				 class="cart-side__product">
          			<img 
    					class="cart-side__product_image" 
    					src="${image}"
    				/>
          			<div class="cart-side__product_info">
                        <p class="cart-side__product_title">${product.title}</p>
    					<p style="margin:0px;">${formatPrice(product.line_price)}</p>
    					<p style="margin:0px;">QTY:${product.quantity}</p>
                        <a onclick="removeProduct('${ product.variant_id }')" 
                           class="cart-side__product_remove" 
                        >
                            REMOVE ITEM
                        </a>
    				</div>
    			</div>
    		</a>`;
}

function toggleSideBarVisibility(action){
  const form = $('#cart');
  const empty_cart = $('#empty_cart');
  const actions = $('#cart-side__wrapper__actions');
  if(action == 'show'){
      form.removeClass('not_visible');
      empty_cart.addClass('not_visible');
      actions.removeClass('not_visible');
  } else {
      form.addClass('not_visible');
      empty_cart.removeClass('not_visible');
      actions.addClass('not_visible');
  }
}

function updateCartLabel(action){
	let cart_icon = $('.header__icon--cart .counter-items');
    const previous =  cart_icon.text();
    const amount = Number(previous.toLowerCase().replace("cart", "").replaceAll(" ", "").replace("(", "").replace(")", ""));
  	const final_amount = action == 'add' ? amount+1 : amount-1;
  	setAmount(final_amount);
   
}
  
function setAmount(amount){
  if(!isNaN(amount)){
    let cart_icon = $('.header__icon--cart .counter-items');
    cart_icon.text("CART ( " + amount + " )");
  }
}

function showToaster(message, type){
  $(".toaster").remove();
  const toasterHTML = `<div class="toaster">
							
							<div class="toaster_message">
								${message}
							</div>
						 </div>`;
	$("body").append(toasterHTML);
  	setTimeout(() => {
    	$(".toaster").remove();
	}, 3500)	
}